import React, { useState, useEffect, useCallback, useMemo } from 'react';
import './Followups.css';
import Header from '../sharedFiles/header/header';
import Footer from '../sharedFiles/footer/footer';
import { GetData } from '../API/getApi';
import { CustomerFollowUp } from '../API/API';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectUser, setCustomerCode } from '../ReduxStore/userReducer';
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import CommonDynamicTable from '../sharedFiles/CommonDynamicTable/CommonDynamicTable';
import { GetSQItems } from '../API/API';
import { resetCrmData } from '../ReduxStore/actions';
import { TablePagination } from '@mui/material';
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import SearchIcon from '@mui/icons-material/Search';
import { fetchOpprtunity, GetLostDoc } from '../API/OpportunityServices/OpprThunk';
import SunspotLoader from "../sharedFiles/loader/loader";
import dayjs from 'dayjs';


const CustomerFollowups = () => {
  const [data, setData] = useState([]);
  const [displayedItems, setDisplayedItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // const [dateRange, setDateRange] = useState({ from: null, to: null });
  const [searchValue, setSearchValue] = useState('');
  const [searchFields, setSearchFields] = useState({});
  const [filteredData, setFilteredData] = useState(data)
  const [showMessage, setShowMessage] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(12);
  const [totalCount, setTotalCount] = useState(0); 
  const [page, setPage] = useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();
const userData = useSelector(selectUser);
const databaseName = userData?.DatabaseName;
const accessLevel = userData?.AccessLevel;
const jwtToken = userData?.JwtToken;
const SlpCode = userData?.slpCode;
  const [menuColumn, setMenuColumn] = useState('');
  const [showSearchBar, setShowSearchBar] = useState(true);
  const [selectedValues, setSelectedValues] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({});
  // const {opprData} = useSelector((state) => state.item);
  const {GetOpportHistory} = useSelector((state) => state.Oppr);
  const [sortConfig, setSortConfig] = useState({ column: 'Due_Days', direction: 'asc' });
  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      if (!GetOpportHistory || !Array.isArray(GetOpportHistory.data)) {
        await dispatch(fetchOpprtunity({databaseName, jwtToken, SlpCode, accessLevel}));
        return; 
      }
      const inpData = GetOpportHistory.data || [];
      setData(inpData);
      setTotalCount(inpData.length);

      if (inpData.length > 0) {
        setLoading(false);
        const firstItem = inpData[0];
        const firstKey = Object.keys(firstItem)[0];
        const formattedColumnName = firstKey
          .replace(/_/g, ' ')
          .replace(/\b\w/g, (char) => char.toUpperCase());
        setSearchValue(formattedColumnName);
      }
      const paginatedData = inpData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
      setDisplayedItems(paginatedData);
      setError(null);
      setLoading(false);

    };

    loadData();
  }, [GetOpportHistory, databaseName,SlpCode, jwtToken, accessLevel, dispatch, rowsPerPage]);

  const handleSqHistory = async (item) => {
    setLoading(true);
    localStorage.setItem('searchFields', JSON.stringify(searchFields));
    localStorage.setItem('filteredData', JSON.stringify(filteredData));
    localStorage.setItem('page', JSON.stringify(page));
    localStorage.setItem('rowsPerPage', JSON.stringify(rowsPerPage));
    localStorage.setItem('sortConfig', JSON.stringify(sortConfig));
    localStorage.setItem('selectedFilters', JSON.stringify(selectedFilters));
    try {
      const response = await GetData(`${GetSQItems}${databaseName}&DocEntry=${item.DocEntry}`,
        {
          headers: {
            wg_token: jwtToken,
          },
        },

        dispatch,
        navigate
      );
      if (Array.isArray(response) && response?.length > 0) {
        setData(response);
        setShowSearchBar(false);
        const paginatedData = response.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
        setDisplayedItems(paginatedData);
        setTotalCount(response.length);
        setPage(0);
      } else {
        setData([]);
        setDisplayedItems([]);
        setError('No data available');
      }
    } catch (err) {
      setError(err.message || 'Error fetching data');
    } finally {
      setLoading(false);
    }
  }
const handleHeaderClick = (col) => {
  const formattedColumnName = col.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
  setSearchFields(prevFields => {
    if (!prevFields[formattedColumnName]) {
      return { ...prevFields, [formattedColumnName]: '' };
    }
    return prevFields;
  });
  setShowMessage(false);
};

  const handleSearchChange = (e, column) => {
    const value = e.target.value;
    // Update the active search field value
    setSearchFields(prevFields => {
      return { ...prevFields, [column]: value };  // Update the specific column's search term
    });
    // console.log("value", value);
  };
  useEffect(() => {
    setShowMessage(true);
    const savedSearchFields = localStorage.getItem('searchFields');
    const savedFilteredData = localStorage.getItem('filteredData');
    const savedPage = localStorage.getItem('page');
    const savedRowsPerPage = localStorage.getItem('rowsPerPage');
    const savedSortConfig = localStorage.getItem('sortConfig');
    const savedSelectedFilters = localStorage.getItem('selectedFilters');
    if (savedSearchFields) {
      setSearchFields(JSON.parse(savedSearchFields));
    }
    if (savedFilteredData) {
      setFilteredData(JSON.parse(savedFilteredData));
    }
    if (savedPage) {
      setPage(Number(savedPage));
    }

    if (savedRowsPerPage) {
      setRowsPerPage(Number(savedRowsPerPage));
    }

    if (savedSortConfig) {
      setSortConfig(JSON.parse(savedSortConfig));
    }

    if (savedSelectedFilters) {
      setSelectedFilters(JSON.parse(savedSelectedFilters));
    }

    // Optionally clear localStorage (or keep for persistent UX)
    localStorage.removeItem('searchFields');
    localStorage.removeItem('filteredData');
    localStorage.removeItem('page');
    localStorage.removeItem('rowsPerPage');
    localStorage.removeItem('sortConfig');
    localStorage.removeItem('selectedFilters');
  }, []);


  //oppor screen nextfollowup  select value
const handleMenuItemClick = (item) => {
  // Check if it's a date range object
  if (typeof item === 'object' && item.from && item.to) {
    setSelectedFilters((prev) => ({
      ...prev,
      [menuColumn]: item, // Save date range as object
    }));
  } else {
    // Handle checkbox filter (array of selected values)
    setSelectedFilters((prev) => {
      const current = prev[menuColumn] || [];
      const isSelected = current.includes(item);
      const updated = isSelected
        ? current.filter(i => i !== item)
        : [...current, item];

      return {
        ...prev,
        [menuColumn]: updated,
      };
    });
  }
};
  const handleSortClick = (column) => {
    let direction = 'asc';

    // Toggle direction if the same column is clicked again
    if (sortConfig.column === column) {
      direction = sortConfig.direction === 'asc' ? 'desc' : 'asc';
    }
    // Update the sort configuration state
    setSortConfig({ column, direction });

    // Perform the sorting
    const sortedData = [...data].sort((a, b) => {
      let aValue = a[column];
      let bValue = b[column];

      // ✅ Special handling for Next_FollowUp (assumes format "DD/MM/YYYY - ...")
      if (column === 'Next_FollowUp') {
        const parseDate = (val) => {
          if (!val) return new Date(0); // fallback if value is null/undefined
          const datePart = val?.split(' - ')[0];
          const [day, month, year] = datePart?.split('/');
          return new Date(`${year}-${month}-${day}`);
        };

        aValue = parseDate(aValue);
        bValue = parseDate(bValue);
      }

      // ✅ Handle numeric comparison if both are numbers
      else if (!isNaN(parseFloat(aValue)) && !isNaN(parseFloat(bValue))) {
        aValue = parseFloat(aValue);
        bValue = parseFloat(bValue);
      }

      // ✅ Handle string comparison as fallback
      else {
        aValue = String(aValue).toLowerCase();
        bValue = String(bValue).toLowerCase();
      }

      if (aValue < bValue) return direction === 'asc' ? -1 : 1;
      if (aValue > bValue) return direction === 'asc' ? 1 : -1;
      return 0;
    });

    // Update the state with sorted data
    setData(sortedData);
  };
  useEffect(() => {
    let currentData = data;
    if (sortConfig.column && sortConfig.direction) {
      currentData = [...currentData].sort((a, b) => {
        let aVal = a[sortConfig.column];
        let bVal = b[sortConfig.column];

        // ✅ Special handling for Next_FollowUp (parse date portion)
        if (sortConfig.column === 'Next_FollowUp') {
          const extractDate = (val) => {
            if (!val) return new Date(0); // fallback for null/undefined
            const datePart = val?.split(' - ')[0];
            const [day, month, year] = datePart?.split('/');
            return new Date(`${year}-${month}-${day}`);
          };
          aVal = extractDate(aVal);
          bVal = extractDate(bVal);
        }
        // ✅ Handle numeric values
        else if (!isNaN(parseFloat(aVal)) && !isNaN(parseFloat(bVal))) {
          aVal = parseFloat(aVal);
          bVal = parseFloat(bVal);
        }
        else {
          aVal = String(aVal);
          bVal = String(bVal);
        }

        if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
        if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
      });
    }

    if (Object.values(searchFields).some((val) => val.trim() !== '')) {
      currentData = currentData.filter((item) => {
        return Object.keys(searchFields).every((col) => {
          const formattedCol = col.replace(/ /g, '_');
          return item.hasOwnProperty(formattedCol)
            ? String(item[formattedCol]).toLowerCase().includes(searchFields[col].toLowerCase())
            : true;
        });
      });
    }

    // ✅ Header filter logic (selectedFilters)
    Object.keys(selectedFilters).forEach((col) => {
      const filterValue = selectedFilters[col];

      // ✅ Date range filtering
      if (typeof filterValue === 'object' && filterValue.from && filterValue.to) {
        const fromDate = new Date(filterValue.from);
        const toDate = new Date(filterValue.to);

        currentData = currentData.filter((item) => {
          const itemDate = new Date(item[col]);
          return itemDate >= fromDate && itemDate <= toDate;
        });
      }

      // ✅ Checkbox filtering
      if (Array.isArray(filterValue) && filterValue.length > 0) {
        currentData = currentData.filter((item) => {
          const normalizedCol = col.replace(/ /g, '_');
          const actualKey = Object.keys(item).find(k => k.toLowerCase() === normalizedCol.toLowerCase());
          if (!actualKey || typeof item[actualKey] === 'undefined'|| item[actualKey] === '') return true;

          const colValue = item[actualKey];
          // Handle FollowUp columns
          if (actualKey === 'Next_FollowUp' || actualKey === 'Last_FollowUp') {
            const secondPart = colValue?.split(' - ')[1];
            if (!secondPart) return false;
            return filterValue.includes(secondPart);
          }

          return filterValue.includes(colValue);
        });
      }

    });
    
    // ✅ Set final filtered data
    setFilteredData(currentData);
    setTotalCount(currentData.length);
    // if (currentData.length <= page * rowsPerPage) {
    //   setPage(0);
    // }
    setDisplayedItems(currentData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage));

  }, [searchFields, data, rowsPerPage, selectedFilters, sortConfig]);

  // reset menu filed and search fields
  const handleResetSearch = () => {
    setSearchFields({})
    // setDateRange({})
    setSelectedValues([]);
  }

  const handleResetFilters = () => {
    setSelectedFilters({});
    // setDateRange({})
    // setDateRange({ from: null, to: null }); 
  };


  const handleRemoveItem = (columnName) => {

    setSearchFields(prevFields => {
      const updatedFields = { ...prevFields };
      delete updatedFields[columnName]; // Remove the column from search fields
      return updatedFields;
    });
    if (Object.keys(searchFields).length === 0) {
      setShowMessage(true);
    }
  };

  //******** Pagination function will start here *************/

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    SlicedItem(newPage, rowsPerPage);  // Directly calling SlicedItem here for pagination
  };

  // Function to handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);  
    SlicedItem(0, newRowsPerPage);  // Directly calling SlicedItem here
  };

  // Slicing logic for data pagination based on filtered data
  const SlicedItem = (page, rowsPerPage) => {
    setLoading(true);
    let dataToPaginate = filteredData; // Use filteredData for pagination
    // Paginate the filtered data (not the full dataset)
    const paginatedData = dataToPaginate.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    setDisplayedItems(paginatedData);
    setLoading(false);
  };

  //********** Pagination function will end here ************/

  const handleFromBackToOppr = () => {
    setShowSearchBar(true);
    setData(GetOpportHistory.data);
    const savedPage = localStorage.getItem('page');
    setPage(Number(savedPage));
    // fetchData();
  }

  const handleOpporitemPage = (opportunityNo) => {
 localStorage.setItem('page', JSON.stringify(page));
    setShowSearchBar(false);
    navigate(`/GetGroupItem`, {
      state: {
        additionalData: "OpporItemPage",
        opportunityNos: opportunityNo.Opp_No
      }
    })
  };
const handleRowClick = (item) => {
  localStorage.setItem('searchFields', JSON.stringify(searchFields));
  localStorage.setItem('filteredData', JSON.stringify(filteredData));
  localStorage.setItem('page', JSON.stringify(page));
  localStorage.setItem('rowsPerPage', JSON.stringify(rowsPerPage));
  localStorage.setItem('sortConfig', JSON.stringify(sortConfig));
  localStorage.setItem('selectedFilters', JSON.stringify(selectedFilters));
  dispatch(GetLostDoc({ dbName: databaseName, OpprNo: item.Opp_No }));
  navigate(`/Opportunity/${item.Opp_No}`);
};

  const handleBackNav = () => {
    dispatch(resetCrmData());
    // dispatch(setCustomerCode({
    //   customerCode: "",
    //   customerName: "",
    //   phoneNum: ""
    // }));
    sessionStorage.removeItem('CRMPostData');
    navigate("/DashBoard"); // Navigate back to the dashboard
  };

  // console.log("searchFields :", Object.keys(searchFields).length);

  if (error) return <p>Error: {error}</p>;


  return (
    <div>
      <Header />
      <div className="dashBoardMain">
        <div className="dashImage"></div>
        <div className="dashGradient"></div>
{showSearchBar && (
  <div className="sqHistorydiv">
<div className="TopHisDiv">
  <div className="d-flex col-4 me-4 me-xl-5 me-xxl-4 col-xl-5 col-xxl-5">
    <button onClick={handleBackNav} className="backIcondiv">
      <ArrowCircleLeftIcon />
      <p className="DashBoardName col-xl-7 col-xxl-11 col-10 col-md-11">Dashboard</p>
    </button>
  </div>
  <div className="opporTitle">
    <p>Opportunity</p>
  </div>
</div>
    <div className="StepperGradient3">
      <div className="search-container">
        {showMessage && (Object.keys(searchFields).length === 0) && (
          <div className="search-message">
            Click on a column header to start searching <SearchIcon />
          </div>
        )}

        {/* Loop through search fields and display search inputs */}
        {Object.keys(searchFields).map((columnName) => (
          <div key={columnName} className='searchfulldiv'>
            <input
              type="text"
              placeholder={`Search By ${columnName}`}
              value={searchFields[columnName]}
              onChange={(e) => handleSearchChange(e, columnName)}
              className="search-input"
            />
            <button
              className='removeIcon'
              onClick={() => handleRemoveItem(columnName)}  // Assuming handleRemoveItem clears that specific field
            >
              <HighlightOffIcon />
            </button>
          </div>
        ))}


        {/* Add a reset button to reset all search fields and checkbox */}
        <div className="reset-buttons">
          {(Object.keys(searchFields).length > 0 || Object.keys(selectedFilters).length > 0) && (
            <>
              {Object.keys(searchFields).length > 0 && (
                <button
                  className="btnsubmitt btn btn-success btn-sm"
                  onClick={handleResetSearch}
                >
                  Reset Search
                </button>
              )}

              {Object.keys(selectedFilters).length > 0 && (
                <button
                  className="btnsubmitt btn btn-success btn-sm"
                  onClick={handleResetFilters}
                >
                  Reset Filters
                </button>
              )}
            </>
          )}
        </div>
      </div>
      <div className="opportable table-border">
        <CommonDynamicTable
          data={displayedItems}
          handleOpportunityClick={handleOpporitemPage}
          onEditRow={handleRowClick}
          onShow={handleSqHistory}
          showEditButton={false}
          dataType="customerFollowups"
          accessLevel={accessLevel}
          Originaldata={data}
          handleMenuItemClick={handleMenuItemClick}
          selectedValues={selectedValues}
          filteredData={filteredData}
          menuColumn={menuColumn}
          setMenuColumn={setMenuColumn}
          selectedFilters={selectedFilters}
          setSelectedValues={setSelectedValues}
          handleHeaderClick={handleHeaderClick}
          
          handleSortClick={handleSortClick}
          sortConfig={sortConfig}
        />
      </div>
    </div>
  </div>
)}

        {!showSearchBar && (
  <div className="sqHistorydiv">
    <div className="TopHisDiv">
      <div className="d-flex col-4 me-4 me-xl-4 me-xxl-4 col-xl-4 col-xxl-5">
        <button onClick={handleFromBackToOppr} className="backIcondiv">
          <ArrowCircleLeftIcon />
          <p className="DashBoardName col-xl-7 col-xxl-11 col-10 col-md-11">SQ History</p>
        </button>
      </div>
      <div className="opporTitle">
        <p>Sales Quotation History</p>
      </div>
    </div>
    <div className="StepperGradient3">
      <div className="opportable table-border">
        <CommonDynamicTable
          data={displayedItems}
          dataType="sqItemhistory"
          showEditButton={false}
        />
      </div>
    </div>
  </div>
)}
        <div className="hispagination">
          <TablePagination
            component="div"
            count={totalCount}  // Total records available
            page={page}         // Current page (for UI)
            onPageChange={handleChangePage}  // Handle page change
            rowsPerPage={rowsPerPage}  // Number of records per page
            onRowsPerPageChange={handleChangeRowsPerPage}  // Handle rows per page change
            rowsPerPageOptions={[12, 24, 48]}  // Options for rows per page
          />
        </div>
      </div>

      <Footer />
      {loading && (
        <div className="loader position-absolute ">
          (<SunspotLoader />)
        </div>
      )}
    </div>
  );
};

export default CustomerFollowups;




// import React, { useState } from 'react';
// import { useCustomerFollowups } from './CustomHooks/useCustomerFollowups';
// import SearchBar from '../sharedFiles/Searchbar/searchbar';
// import { Pagination } from 'react-bootstrap';
// import Header from '../sharedFiles/header/header';
// import Footer from '../sharedFiles/footer/footer';
// import './Followups.css';
// import CommonDynamicTable from '../sharedFiles/CommonDynamicTable/CommonDynamicTable';
// import SunspotLoader from "../sharedFiles/loader/loader";
// import { useDispatch, useSelector } from 'react-redux';
// import { GetLostDoc, getSQItems } from '../API/OpportunityServices/OpprThunk';
// import { useNavigate } from 'react-router-dom';
// import { selectUser } from '../ReduxStore/userReducer';
// import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
// import { TablePagination } from '@mui/material';
// import { resetCrmData } from '../ReduxStore/actions';



// const CustomerFollowups = () => {
//   const {
//     data,
//     displayedItems,
//     error,
//     searchFields, sortConfig,
//     handleSearchChange,
//     handleSortClick,
//     handlePageChange,
//     handleRowsPerPageChange,
//     rowsPerPage,
//     totalCount,
//     page,
//     setSearchFields,
//     setSelectedFilters, selectedFilters,
//   } = useCustomerFollowups();
//   const userData = useSelector(selectUser);
//   const databaseName = userData?.DatabaseName;
//   const accessLevel = userData?.AccessLevel;
//   const jwtToken = userData?.JwtToken;
//   const SlpCode = userData?.slpCode;
//   const [menuColumn, setMenuColumn] = useState('');
//   const [showItems, setShowItems] = useState(false);
//   const { GetOpportHistory, loading } = useSelector((state) => state.Oppr);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const handleOpporitemPage = (opportunityNo) => {
//     localStorage.setItem('page', JSON.stringify(page));
//     //  setShowSearchBar(false);
//     navigate(`/GetGroupItem`, {
//       state: {
//         additionalData: "OpporItemPage",
//         opportunityNos: opportunityNo.Opp_No
//       }
//     })
//   };
//   const handleRowClick = (item) => {
//     dispatch(GetLostDoc({ dbName: databaseName, OpprNo: item.Opp_No }));
//     navigate(`/Opportunity/${item.Opp_No}`);
//   };

//   const handleSqHistory = (item) => {
//     setShowItems(true);
//     dispatch(getSQItems({ databaseName, DocEntry: item.DocEntry }))
//   }
//   const handleHeaderClick = (col) => {
//     const formattedColumnName = col.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
//     setSearchFields(prevFields => {
//       if (!prevFields[formattedColumnName]) {
//         return { ...prevFields, [formattedColumnName]: '' };
//       }
//       return prevFields;
//     });
//     // setShowMessage(false);
//   };
//   const handleRemoveItem = (columnName) => {
//     setSearchFields(prevFields => {
//       const updatedFields = { ...prevFields };
//       delete updatedFields[columnName]; // Remove the column from search fields
//       return updatedFields;
//     });
//     if (Object.keys(searchFields).length === 0) {
//       // setShowMessage(true);
//     }
//   };
//   const handleMenuItemClick = (item) => {
//     // Check if it's a date range object
//     if (typeof item === 'object' && item.from && item.to) {
//       setSelectedFilters((prev) => ({
//         ...prev,
//         [menuColumn]: item, // Save date range as object
//       }));
//     } else {
//       // Handle checkbox filter (array of selected values)
//       setSelectedFilters((prev) => {
//         const current = prev[menuColumn] || [];
//         const isSelected = current.includes(item);
//         const updated = isSelected
//           ? current.filter(i => i !== item)
//           : [...current, item];

//         return {
//           ...prev,
//           [menuColumn]: updated,
//         };
//       });
//     }
//   };
//   if (error) return <p>Error: {error}</p>;
//   const handleFromBackToOppr = () => {
//     setShowItems(false);
//     // setData(GetOpportHistory.data);
//     // fetchData();
//   }
//   const handleBackNav = () => {
//     dispatch(resetCrmData());
//     // dispatch(setCustomerCode({
//     //   customerCode: "",
//     //   customerName: "",
//     //   phoneNum: ""
//     // }));
//     sessionStorage.removeItem('CRMPostData');
//     navigate("/DashBoard"); // Navigate back to the dashboard
//   };
//   return (
//     <div>
//       <Header />
//       <div className="dashBoardMain">
//         <div className="dashImage"></div>
//         <div className="dashGradient"></div>
//         {!showItems ? (
//           <div className="sqHistorydiv">
//             <div className="TopHisDiv">
//               <div className="d-flex col-4 me-4 me-xl-5 me-xxl-4 col-xl-5 col-xxl-5">
//                 <button onClick={handleBackNav}className="backIcondiv">
//                   <ArrowCircleLeftIcon />
//                   <p className="DashBoardName col-xl-7 col-xxl-11 col-10 col-md-11">Dashboard</p>
//                 </button>
//               </div>
//               <div className="opporTitle">
//                 <p>Opportunity</p>
//               </div>
//             </div>
            
//             <SearchBar
//               searchFields={searchFields}
//               handleSearchChange={handleSearchChange}
//             handleRemoveItem={handleRemoveItem} 
//             />

//             <div className="opportable table-border">
//               <CommonDynamicTable
//                 data={displayedItems}
//                 Originaldata={data}
//                 handleOpportunityClick={handleOpporitemPage}
//                 onEditRow={handleRowClick}
//                 selectedFilters={selectedFilters}
//                 accessLevel={accessLevel}
//                 onShow={handleSqHistory}
//                 setMenuColumn={setMenuColumn}
//                 menuColumn={menuColumn}
//                 handleMenuItemClick={handleMenuItemClick}
//                 handleHeaderClick={handleHeaderClick}
//                 showEditButton={false}
//                 dataType="customerFollowups"
//                 sortConfig={sortConfig}
//                 handleSortClick={handleSortClick}
//               />
//             </div>
//           </div>
//         ) : (
//           <div className="sqHistorydiv">
//             <div className="TopHisDiv">
//               <div className="d-flex col-4 me-4 me-xl-4 me-xxl-4 col-xl-4 col-xxl-5">
//                 <button onClick={handleFromBackToOppr}className="backIcondiv">
//                   <ArrowCircleLeftIcon />
//                   <p className="DashBoardName col-xl-7 col-xxl-11 col-10 col-md-11">SQ History</p>
//                 </button>
//               </div>
//               <div className="opporTitle">
//                 <p>Sales Quotation History</p>
//               </div>
//             </div>
//             <div className="StepperGradient3">
//               <div className="opportable table-border">
//                 <CommonDynamicTable
//                   data={displayedItems}
//                   dataType="sqItemhistory"
//                   showEditButton={false}
//                 />
//               </div>
//             </div>
//           </div>
//         )}
//  <div className="hispagination">
//         <TablePagination
//           count={totalCount}
//           page={page}
//           rowsPerPage={rowsPerPage}
//           onPageChange={handlePageChange}
//           onRowsPerPageChange={handleRowsPerPageChange}
//         />
//         </div>
//       </div>
//       <Footer />
//       {/* {loading && <div className="loader position-absolute ">(<SunspotLoader />)</div>} */}
//     </div>
//   )
// }

// export default CustomerFollowups;
